// extracted by mini-css-extract-plugin
module.exports = {"color":"'../../css/colors.css'","textColor":"#575757","main":"Page404_main__2V2W3"};